export { default as DevicesPage } from './DevicesPage.vue'
export { default as SwitchDevices } from './SwitchDevices.vue'
export { default as DeviceDetailsPage } from './DeviceDetailsPage.vue'

